// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3NMwE","container":"styles_container__kJ972","title":"styles_title__3ehsX","wrapper":"styles_wrapper__1DjAT","answer":"styles_answer__3m-06"};